import SplitPageHero from '../common/SplitPageHero'
import { aboutHero } from '../../data/aboutPageData'

const aboutHeroImage = '/assets/about-hero-port.png'

function AboutPageHero() {
  const { eyebrow, titleLine1, titleAccent, titleLine2, description, primaryCta, secondaryCta } =
    aboutHero

  return (
    <SplitPageHero
      id="about-page-heading"
      eyebrow={eyebrow}
      breadcrumbTitle="About Us"
      title={
        <>
          {titleLine1}
          <br />
          <span className="split-page-hero__title-accent">{titleAccent}</span>
          {titleLine2}
        </>
      }
      description={description}
      image={aboutHeroImage}
      imageAlt="Cargo ship and container terminal at sunset with gantry crane and forklift"
      primaryCta={primaryCta}
      secondaryCta={secondaryCta}
    />
  )
}

export default AboutPageHero
